import React from "react";
import AccountDetail from "../../organisms/InitialPagesComponents/BankKyc/Accountdetail/AccountDetail";

function BankAccountDetailPage() {
  return <AccountDetail />;
}

export default BankAccountDetailPage;
